import React from 'react';

import { FilterSelect, PrimaryFilters } from 'filters';
import { FILTER_ACTION_TYPE } from 'scenes/FinancePage/constants';
import { loadActionTypes } from 'scenes/FinancePage/sources/filters/loadActionTypes';

const FiltersPrimary = ({ initialValues = {}, onSubmit }: any) => {
  return (
    <PrimaryFilters initialValues={initialValues} onSubmit={onSubmit}>
      <FilterSelect
        label={'Show'}
        name={FILTER_ACTION_TYPE}
        source={loadActionTypes}
      />
    </PrimaryFilters>
  );
};

export default FiltersPrimary;
